export default __webpack_public_path__ + "static/media/dxzg_vx.a0ef41e3.jpg";